var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    color: "#D14343",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.398926 6.18478C0.398926 9.30478 2.92543 11.8318 6.04475 11.8318C9.16406 11.8318 11.6906 9.30478 11.6906 6.18478C11.6906 3.06478 9.16406 0.53772 6.04475 0.53772C2.92543 0.53772 0.398926 3.06478 0.398926 6.18478ZM8.18042 3.52936C8.54582 3.52936 8.84478 3.82832 8.84478 4.19372C8.84478 4.37974 8.7717 4.54583 8.65211 4.66542L7.13073 6.1868L8.65211 7.70819C8.7717 7.82777 8.84478 7.99386 8.84478 8.17988C8.84478 8.54528 8.54582 8.84424 8.18042 8.84424C7.9944 8.84424 7.82831 8.77116 7.70872 8.65158L6.18734 7.13019L4.66596 8.65158C4.54637 8.77116 4.38028 8.84424 4.19426 8.84424C3.82886 8.84424 3.5299 8.54528 3.5299 8.17988C3.5299 7.99386 3.60298 7.82777 3.72256 7.70819L5.24395 6.1868L3.72256 4.66542C3.60298 4.54583 3.5299 4.37974 3.5299 4.19372C3.5299 3.82832 3.82886 3.52936 4.19426 3.52936C4.38028 3.52936 4.54637 3.60244 4.66596 3.72867L6.18734 5.25005L7.70872 3.72203C7.82831 3.60244 7.9944 3.52936 8.18042 3.52936Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilled);
export default __webpack_public_path__ + "static/media/delete-filled.b3a278ed.svg";
export { ForwardRef as ReactComponent };